import { useIntl } from 'react-intl';
import { formatVariable, LoadingSkeleton } from 'sonata-react-components';

import { useDoohInventory } from '@/context/DoohInventoryContext';
import { DoohInventoryVolumetryLoadingStyled, DoohInventoryVolumetryStyled } from './DoohInventoryVolumetry.styled';

function DoohInventoryVolumetry() {
  const { formatMessage } = useIntl();
  const { isInventoryLoading, volumetry } = useDoohInventory();

  if (isInventoryLoading || !volumetry) {
    return (
      <DoohInventoryVolumetryLoadingStyled>
        <LoadingSkeleton height={35} />
      </DoohInventoryVolumetryLoadingStyled>
    );
  }

  return (
    <DoohInventoryVolumetryStyled className="doohInventoryVolumetry">
      <div className="doohInventoryVolumetry__metric">
        <span className="doohInventoryVolumetry__metricValue">{formatVariable(volumetry.publishers, 0)}</span>
        <span className="doohInventoryVolumetry__metricName">
          {formatMessage({
            defaultMessage: 'Publisher',
            id: 'doohInventory.volumetry.publisher'
          })}
        </span>
      </div>
      <div className="doohInventoryVolumetry__metric">
        <span className="doohInventoryVolumetry__metricValue">{formatVariable(volumetry.venueTypes, 0)}</span>
        <span className="doohInventoryVolumetry__metricName">
          {formatMessage({
            defaultMessage: 'Venue Type',
            id: 'doohInventory.volumetry.venueType'
          })}
        </span>
      </div>
      <div className="doohInventoryVolumetry__metric">
        <span className="doohInventoryVolumetry__metricValue">{formatVariable(volumetry.screens, 0)}</span>
        <span className="doohInventoryVolumetry__metricName">
          {formatMessage({
            defaultMessage: 'Screen',
            id: 'doohInventory.volumetry.screen'
          })}
        </span>
      </div>
      <div className="doohInventoryVolumetry__metric">
        <span className="doohInventoryVolumetry__metricValue">{formatVariable(volumetry.screenTypes, 0)}</span>
        <span className="doohInventoryVolumetry__metricName">
          {formatMessage({
            defaultMessage: 'Screen Type',
            id: 'doohInventory.volumetry.screenType'
          })}
        </span>
      </div>
      <div className="doohInventoryVolumetry__metric">
        <span className="doohInventoryVolumetry__metricValue">{formatVariable(volumetry.countries, 0)}</span>
        <span className="doohInventoryVolumetry__metricName">
          {formatMessage({
            defaultMessage: 'Countries',
            id: 'doohInventory.volumetry.countries'
          })}
        </span>
      </div>
    </DoohInventoryVolumetryStyled>
  );
}

export default DoohInventoryVolumetry;
